@if (initialized) {
<!--  <div class="surface-section mb-5">-->
  <ng-content></ng-content>
  <core-upload
    [busy]="busy"
    (onDocumentUploaded)="onDocumentUpload($event)"
  ></core-upload>
<!--  // Ticket: WEK1000001202-->
  <div class="my-5 flex justify-content-center">
    <p-button (click)="showDialog()" styleClass="" [outlined]="true" icon="pi pi-file-import text-xl mr-2"
              label="Manuell eingeben"></p-button>
  </div>
<!--  </div>-->


  @if (userAddedInsuranceDto && userAddedInsuranceDto.length > 0) {
    <hr class="my-4 -mx-5 border-blue-50" style="border-width: 2rem 0 0 0;">
    <p-dataView #dv [value]="userAddedInsuranceDto" [rows]="5" [paginator]="true"
                emptyMessage="Noch keine Verträge erfasst">
      <ng-template let-insurance pTemplate="list">
        <div class="grid grid-nogutter">
          @for (item of insurance; track item.id) {

            <div class="col-12 my-4">
              <div class="flex flex-column border-1 surface-border border-round">

                <!--                @if (item.insuranceCompanyDtoName && item.insuranceTypeDtoName) {-->
                <div class="flex justify-content-between surface-100 py-2 px-4 align-items-center">

                  <div class="flex flex-column align-items-center sm:align-items-start gap-1">
                    <div class="text-xl font-bold text-color">{{ item.insuranceCompanyDtoName || '-' }}</div>

                    <div class="flex align-items-center" *ngIf="item.insuranceTypeDtoName">
                                <span class="flex align-items-center gap-2 text-color-secondary">
                                    <i class="pi pi-tag"></i>
                                    <span class="font-semibold">{{ item.insuranceTypeDtoName }}</span>
                                </span>
                    </div>
                  </div>
                  <div class="cursor-pointer" (click)="onSelectUserInsurance(item)">
                    <i class="pi pi-file-edit"></i>
                  </div>
                </div>

                <!--                }-->
                @if (item.documents && item.documents.length) {
                  <div class="grid m-0 px-2 py-4 bg-blue-50">
                    @for (document of item.documents; track document.id) {
                      <section class="lg:col-3 col-12">
                        <div class="card p-2 shadow-1">
                          <div
                            class="flex justify-content-between p-3 pt-2 border-bottom-1 border-200 m-2 align-items-center">
                            <h5 class="pdf-card-title text-sm m-0 mr-2">{{ document.name }}</h5>
                            <div class="flex gap-3">
                              <i
                                class="pi pi-window-maximize cursor-pointer"
                                (click)="showDocument($event,document)"
                              ></i>
                              <i
                                class="pi pi-trash cursor-pointer text-red-600"
                                (click)="onDeleteDocument($event,document.insuranceId,document.id)"
                              ></i>
                            </div>
                          </div>
                          <div class="p-1 h-12rem overflow-hidden">
                            <app-pdf-view [objectService]="insurableObjectService" [documentId]="document.id"
                                          [addedId]="document.insuranceId"
                                          class="w-full h-full"></app-pdf-view>
                          </div>
                        </div>
                      </section>
                    }
                  </div>
                }


              </div>
            </div>
          }

        </div>
      </ng-template>
    </p-dataView>

  }
}

<p-dialog header="Manuell eingeben" [modal]="true" [(visible)]="visible"
          styleClass="custom-header-padding" [style]="{width: '50rem'}" (onHide)="onDialogHide()">
  <div class="grid">

    <div class="col-12 flex justify-content-center">
      @if (tempForm) {

        <form [formGroup]="tempForm">
          <div class="grid mt-3">
            @for (field of insuranceFieldsList; track field.id) {
              @if (field.access == FieldAccess.UPDATE || field.access == "update") {
                <div class="col-12 flex flex-column justify-content-center gap-1 mb-2" [formGroup]="tempForm">

                  <div class="font-medium text-900">
                    {{ field.uiLabel }} <span *ngIf="field.uiMandatory"
                                              class="text-red-400 font-normal">(Erforderlich)</span>
                  </div>
                  <div>

                    <!-- Input Text -->
                    @if (field.uiInputControl === 'text') {
                      <input
                        placeholder="{{field.uiPlaceholder}}"
                        class="w-full"
                        pInputText
                        type="text"
                        [formControlName]="field.id">
                    } @else if (field.uiInputControl === 'selectHierarchy') {
                      <p-dropdown
                        [formControlName]="field.id"
                        [options]="field.valueList?.entries"
                        [filter]="true"
                        styleClass="w-full"
                        class="w-full"
                        optionLabel="label"
                        optionValue="key"
                        placeholder="{{field.uiPlaceholder}}"
                      ></p-dropdown>
                    } @else if (field.uiInputControl === 'checkbox') {
                      <p-selectButton
                        [options]="
                                [
                                    { label: 'Ja', value: true },
                                    { label: 'Nein', value: false }

                                ]"
                        [formControlName]="field.id"
                        [allowEmpty]="false"
                        optionLabel="label"
                        optionValue="value"
                      ></p-selectButton>
                    } @else if (field.uiInputControl === 'textarea') {
                      <textarea
                        rows="5"
                        cols="30"
                        pInputTextarea
                        class="w-full"
                        placeholder="{{field.uiPlaceholder}}"
                        [formControlName]="field.id">>
                      </textarea>
                  } @else if (field.uiInputControl == undefined) {
                      <form-field-auto-complete [formGroup]="tempForm"
                                                [formField]="field">
                      </form-field-auto-complete>
                    }

                  </div>
                </div>
              }
            }
          </div>
        </form>
      }
    </div>

    <div class="flex justify-content-end gap-3 w-full mt-4">
      @if (tempForm) {
        @if (tempForm.get('id')?.value) {
          <p-button label="Entfernen"
                    icon="pi pi-trash"
                    severity="danger"
                    (click)="onDeleteInsuranceForm(tempForm.get('id')?.value)">
          </p-button>

          <!--          <app-button [busy]="busy"-->
            <!--                      [label]="'Löschen'"-->
            <!--                      [icon]="'pi pi-trash'"-->
            <!--                      [severity]="'danger'"-->
            <!--                      (onClick)="onDeleteInsuranceForm(tempForm.get('id')?.value)">-->
            <!--          </app-button>-->

        }
        <p-button icon="pi pi-save"
                  [disabled]="!isFormValid()"
                  [label]="tempForm.get('id')?.value ? 'Speichern' : 'Anlegen'"
                  (click)="onSaveInsuranceForm(tempForm)"></p-button>

        <!--        <app-button [busy]="busy"-->
          <!--                    [label]="tempForm.get('id')?.value ? 'Speichern' : 'Anlegen'"-->
          <!--                    [icon]="'pi pi-save'"-->
          <!--                    (onClick)="onSaveInsuranceForm(tempForm)">-->
          <!--        </app-button>-->
      }
    </div>

  </div>
</p-dialog>


<p-dialog
  [header]="selectedDocument?.name"
  [(visible)]="documentVisible"
  [style]="{width: '65rem', height: '75vh'}"
  [modal]="true"
  (onHide)="onDialogHide()">
  @if (blob) {
    <app-pdf-view [blob]="blob"
                  (handleNewWindowOpened)="handleWindowOpened($event)"
                  class="w-full h-full"></app-pdf-view>
  }

</p-dialog>

<p-confirmDialog></p-confirmDialog>
